// §116 — application name shown in the browser tab, sidebar and login page:
// « ProGest - <instance> », the instance being derived from the Firebase project of the build.
const INSTANCE_NAMES: Record<string, string> = {
  'sae-lanaudiere': 'Lanaudière',
  'sae-laurentides': 'Laurentides',
  'projetsae-501312': 'Dev',
};

export const INSTANCE_NAME = INSTANCE_NAMES[process.env.REACT_APP_FIREBASE_PROJECT_ID ?? ''] ?? '';
export const APP_NAME = INSTANCE_NAME ? `ProGest - ${INSTANCE_NAME}` : 'ProGest';
